import { Brand } from '@blade/std-lib'

export const TxSignedTypeId = 'tradebot-tma/TxSigned'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TxSignedTypeId = typeof TxSignedTypeId

export type TxSigned = Brand.Branded<string, TxSignedTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TxSigned = Brand.nominal<TxSigned>()
